const customerContactMoments = {
  firestorePath: '/customerContactMoments',
  firestoreRefType: 'collection',
  moduleName: 'customerContactMoments',
  statePropName: 'customerContactMoments',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%',
      updated_at: '%convertTimestamp%',
    },
  },
  state: {
    customerContactMoments: {},
  },
  getters: {
    getCustomerContactMoments: (state) => {
      return _.toArray(state.customerContactMoments);
    },
  },
  mutations: {},
  actions: {},
};

export default customerContactMoments;
